import React from 'react';

import {wishlistOptions, wishlistTypes} from "../../util/WishlistUtils";

const getOptions = async () => wishlistOptions
    .filter(item => {

        if(item.enabled && item.type !== wishlistTypes.default)
            return item
    })
    .map( item => ({
    id:item?.type?.description,
    value: item?.type?.description,
    label:<label> { item?.code } </label>
}))

export const wishlistServiceProvider = {
    getOptions
}